import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { MDSIcon } from '@marqvision/mds-v2';
import { useSlider } from '../@hooks/useSlider';

const useStyles = makeStyles(() => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '6px',
    position: 'absolute',
    bottom: '0',
    left: '0',
    width: '100%',
    paddingBottom: '16px',
  },
  button: {
    padding: '0',
    margin: '0',
    backgroundColor: 'transparent',
    border: 'none',
    borderRadius: '50%',
    transition: '0.3s',
    opacity: '0.7',
    cursor: 'pointer',

    '&.selected': {
      opacity: '1',
    },

    '&:hover': {
      opacity: '1',
    },

    '& svg': {
      filter: 'drop-shadow(0px 1px 2px 0px rgba(0, 0, 0, 0.04)) drop-shadow(0px 1px 8px 0px rgba(0, 0, 0, 0.12))',
      transition: '0.3s',
    },
  },
}));

type Props = ReturnType<typeof useSlider>['indicatorProps'];

export const Indicator = (props: Props) => {
  const { maxIndex, selectedIndex, onClick } = props;
  const classes = useStyles();

  const indicatorCount = maxIndex + 1;

  return (
    <div className={classes.wrapper}>
      {indicatorCount > 1 &&
        [...Array(indicatorCount)].map((_, index) => (
          <button
            key={`button-${index}`}
            className={clsx(classes.button, { selected: selectedIndex === index })}
            onClick={onClick(index)}
          >
            <MDSIcon.Circle
              variant="fill"
              color="color/content/inverse/default/normal"
              size={selectedIndex === index ? 8 : 6}
            />
          </button>
        ))}
    </div>
  );
};
